import { gql } from "@apollo/client";

export const AddStockUoM = gql`
  mutation AddStockUoM(
    $token: String!
    $customer_id: ID!
    $input: CreateAtsStckUoMInput!
    $user_details: SubscribedUser!
  ) {
    AddStockUoM(
      token: $token
      customer_id: $customer_id
      input: $input
      user_details: $user_details
    )
  }
`;

export const UpdateStockUoM = gql`
  mutation UpdateStockUoM(
    $token: String!
    $uom_id: ID!
    $user_details: SubscribedUser!
    $input: UpdateAtsStckUoMInput!
  ) {
    UpdateStockUoM(
      token: $token
      uom_id: $uom_id
      user_details: $user_details
      input: $input
    )
  }
`;

export const DeleteStockUom = gql`
  mutation DeleteStockUoM(
    $token: String!
    $uom_id: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteStockUoM(token: $token, uom_id: $uom_id, user_details: $user_details)
  }
`;
